/*
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 */

jQuery(document).ready(function($) {

	var stickyHeaderWidth = 1200,
		stickyHeaderStart = 200,
		headerOffset      = 80;

	//--------------------------------------------
	// Menus
	//--------------------------------------------

	$('#header-a #main-menu, #header-b #main-menu, #header-d #main-menu').argonmenu({

		resizeWidth: '5000',
		collapserTitle: '',
		animSpeed: 'medium',
		easingEffect: null,
		indentChildren: false,
		childrenIndenter: '&nbsp;'

	});

	$('#main-menu a').focus(function(){
		$(this).parent().find('ul').show();
	});

	$('#main-menu a[href="#"]').click(function(){

		return false;

	});

	$('#header-b .nav-icon').click(function(){

		$('body').toggleClass('nav-open');
		$('#header-b .current-menu-item .sub-menu, #header-b .current-menu-ancestor .sub-menu').show();
		$('#header-b .current-menu-item .sub-collapser, #header-b .current-menu-ancestor .sub-collapser').addClass('expanded');

	});

	$('#header-b .current-menu-item .sub-menu, #header-b .current-menu-ancestor .sub-menu').show();
	$('#header-b .current-menu-item .sub-collapser, #header-b .current-menu-ancestor .sub-collapser').addClass('expanded');

	//--------------------------------------------
	// Sticky Header
	//--------------------------------------------

	var stickyHeader = $('#header-a, #header-b, #header-c, #header-d');

	function rpjcStickyHeader() {

		var screenSize = $(window).width(),
			scrollTop  = $(document).scrollTop(),
			wrapper    = $('#wrapper');

		if (screenSize < stickyHeaderWidth ) return;

		if ( scrollTop > stickyHeaderStart ) {

			$(stickyHeader).addClass('stuck');
			$(wrapper).addClass('header-stuck');

		} else {

			$(stickyHeader).removeClass('stuck');
			$(wrapper).removeClass('header-stuck');

		}

	}

	// rpjcStickyHeader();
	//
	// $(window).scroll(rpjcStickyHeader);

	//--------------------------------------------
	// Site Search
	//--------------------------------------------

	$('.toggle-search').click(function() {

		$('body').toggleClass('search-open');

		$('.site-search input[type="text"]').focus();

		return false;

	});

	$('.site-search-close').click(function() {

		$('body').toggleClass('search-open');

		return false;

	});

	//--------------------------------------------
	// Carousels
	//--------------------------------------------

	$('#slider').slick({

		autoplay: true,
		autoplaySpeed: 5000,
		arrows: true,
		prevArrow: '<span class="slider-arrow prev icon-arrows-left"></span>',
		nextArrow: '<span class="slider-arrow next icon-arrows-right"></span>',
		dots: true

	});

	$('#landing .slider').slick({

		autoplay: true,
		autoplaySpeed: 5000,
		speed: 1000,
		fade: true,
		arrows: true,
		prevArrow: '<span class="slider-arrow prev icon-arrows-left"></span>',
		nextArrow: '<span class="slider-arrow next icon-arrows-right"></span>',
		dots: false,
		pauseOnFocus: false,
		pauseOnHover: false

	});

	$('.section-testimonials .slider').slick({

		autoplay: true,
		autoplaySpeed: 5000,
		arrows: false,
		prevArrow: '<span class="slider-arrow prev icon-arrows-left"></span>',
		nextArrow: '<span class="slider-arrow next icon-arrows-right"></span>',
		dots: true,
		fade: true

	});

	$('.logo-scroller .slider').slick({
		dots: false,
		arrows: false,
		autoplay: true,
		pauseOnFocus: false,
		pauseOnHover: false,
		infinite: true,
		draggable: false,
		speed: 1000,
		slidesToShow: 5,
		slidesToScroll: 1,
		responsive: [
			{
				breakpoint: 900,
				settings: {
					slidesToShow: 4
				}
			},
			{
				breakpoint: 700,
				settings: {
					slidesToShow: 3
				}
			},
			{
				breakpoint: 540,
				settings: {
					slidesToShow: 2
				}
			}
		]
	});

	$('.section-slides').slick({

		autoplay: true,
		autoplaySpeed: 5000,
		arrows: false,
		dots: false

	});

	$('.slider-gallery .slider-for').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: false,
		fade: true,
		asNavFor: '.slider-nav'
	});

	$('.slider-gallery .slider-nav').slick({
		slidesToShow: 5,
		slidesToScroll: 1,
		asNavFor: '.slider-for',
		arrows: true,
		prevArrow: '<span class="slider-arrow prev icon-arrows-left"></span>',
		nextArrow: '<span class="slider-arrow next icon-arrows-right"></span>',
		centerMode: false,
		focusOnSelect: true
	});

	//--------------------------------------------
	// Lightbox
	//--------------------------------------------

	$('.lightbox-image').magnificPopup({
		closeBtnInside: false,
		mainClass: 'rpjc-magnific',
		closeMarkup: '<div title="%title%" class="mfp-close"><span></span><span></span></div>',
		type: 'image'
	});

	$('.lightbox-iframe').magnificPopup({
		closeBtnInside: false,
		mainClass: 'rpjc-magnific',
		closeMarkup: '<div title="%title%" class="mfp-close"><span></span><span></span></div>',
		type: 'iframe'
	});

	$('.lightbox-team').magnificPopup({
		closeBtnInside: false,
		mainClass: 'rpjc-magnific rpjc-magnific-team',
		closeMarkup: '<div title="%title%" class="mfp-close"><span></span><span></span></div>',
		type: 'ajax',
		fixedContentPos: true
	});

	$('.gallery-item').magnificPopup({
		delegate: 'a',
		closeBtnInside: false,
		mainClass: 'rpjc-magnific',
		closeMarkup: '<div title="%title%" class="mfp-close"><span></span><span></span></div>',
		type: 'image',
		gallery: {
			enabled: true,
			arrowMarkup: '<div title="%title%" class="mfp-arrow mfp-arrow-%dir%"><span></span><span></span></div>'
		}
	});

	//--------------------------------------------
	// Accordion
	//--------------------------------------------

	$('.accordion .accordion-content').hide();

	var hash = window.location.hash;

	// check if there's hash tag in the URL
	if (hash.length) {

		var selectedAccordionItem = $('body').find('.accordion .accordion-item' + hash);

		// if yes, open the matching accordion item
		if (selectedAccordionItem.length) {

			selectedAccordionItem.addClass('selected').find('.accordion-content').show();

			// perform scroll down but add in 140 padding for the sticky header
			$('html, body').animate({scrollTop: selectedAccordionItem.offset().top - 140},'slow');

		}

	}

	$('.accordion-handle').click(function(){

		var accordion = $(this).parent().parent();

		if ($('.accordion-content').not(':animated')) {

			if ($(this).parent().hasClass('selected')) {

				$(this).next().slideUp(300).end().parent().removeClass('selected');

			} else {

				$(accordion).find('.accordion-item').removeClass('selected');
				$(this).parent().addClass('selected');
				$(accordion).find('.accordion-content').slideUp(300);
				$(this).next().slideDown(300);

			}

		}

		return false;

	});

	//--------------------------------------------
	// Tabs
	//--------------------------------------------

	$('.tabbed-content .tab-nav li:first-child').addClass('active');
	$('.tabbed-content .tab-window .tab-panel').not(':first-child').hide();

	$('.tabbed-content .tab-nav a').click(function(){

		var target = $(this).attr('href');

		$(this).parent().addClass('active').siblings().removeClass('active');

		$(target).show().siblings().hide();

		return false;

	});

	//--------------------------------------------
	// Scrolling
	//--------------------------------------------

	// Scroll to element

	$('.scroll-to').click(function(){

		var selected = $(this).attr('href'),
			scrollPx = ($(window).width() < stickyHeaderWidth) ? $(selected).offset().top - 20 : $(selected).offset().top - headerOffset;

		$('html, body').animate({scrollTop: scrollPx},'slow');

		return false;

	});

	// Scroll to top link

	$('a[href="#top"]').click(function(){

		$('html, body').animate({scrollTop:0}, 'slow');

		return false;

	});

	$('.scroll-down, .scrolldown').click(function(){

		var target = $(this).parent().next(),
			distance;

		if ($(window).width() < 960) {

			//distance = $(target).offset().top - 60;
			distance = $(target).offset().top;


		} else {

			// distance = $(target).offset().top - 105;
			distance = $(target).offset().top;

		}

		$('html, body').animate({scrollTop: distance},'slow');

		openSideNav(true);

		return false;

	});

    //--------------------------------------------
	// Responsive Horizontal Scrolling
	//--------------------------------------------

	$( '.responsive-scroll' ).each( function() {

		var element       = $( this ),
			scrollWrapper = $( '<div />', {

				'class' : 'scrollable',
				'html'  : '<div class="scrollable-inner" />'

			} ).insertBefore( element );

		element.data( 'scrollWrapper', scrollWrapper );
		element.appendTo( scrollWrapper.find( 'div' ) );

		if ( element.outerWidth() > element.parent().outerWidth() ) {

			element.data( 'scrollWrapper' ).addClass( 'has-scroll' );

		}

		$( window ).on( 'resize orientationchange', function() {

			if ( element.outerWidth() > element.parent().outerWidth() ) {

				element.data( 'scrollWrapper' ).addClass( 'has-scroll' );

			} else {

				element.data( 'scrollWrapper' ).removeClass( 'has-scroll' );

			}

		} );

	} );

	//--------------------------------------------
	// Add placeholder support for older browsers
	//--------------------------------------------

	if(!Modernizr.input.placeholder){

		$('[placeholder]').focus(function() {

			var input = $(this);

			if (input.val() === input.attr('placeholder')) {
				input.val('');
				input.removeClass('placeholder');
			}

		}).blur(function() {

			var input = $(this);

			if (input.val() === '' || input.val() === input.attr('placeholder')) {

				input.addClass('placeholder');
				input.val(input.attr('placeholder'));

			}

		}).blur();

		$('[placeholder]').parents('form').submit(function() {

			$(this).find('[placeholder]').each(function() {

				var input = $(this);

				if (input.val() === input.attr('placeholder')) {

					input.val('');

				}

			});

		});

	}

	//--------------------------------------------
	// fitVids
	//--------------------------------------------

	$('.main').fitVids();

	$('.content-block').fitVids();

	//--------------------------------------------
	// Scroll to section
	//--------------------------------------------

	var hash = window.location.hash;

	// check if there's hash tag in the URL
	if (hash.length) {

		var hashedItem = $('body').find(hash);

		// if yes, open the matching accordion item
		if (hashedItem.length) {

			// perform scroll down but add in 140 padding for the sticky header
			$('html, body').animate({scrollTop: hashedItem.offset().top},'slow');

		}
	}

	$('.anchor a').click(function(event) {

		$('.anchor a').css('color', '#FFF');

		$(this).css('color', '#666767');

		var thisObj = this,
				currenUrl = window.location.href.split('#'),
				currentUri = currenUrl[0];

		if ( $(this).find('a').length ) {
			thisObj = $(this).find('a');
		}

		var targetUrl = $(thisObj).attr('href').split('#'),
				targetUri = targetUrl[0],
				hash = targetUrl[1];

		if (currentUri !== targetUri) {
			return true;
		}

		// check if there's hash tag in the URL
		if (hash.length) {

			var hashedItem = $('#' + hash);

			// if yes, open the matching item
			if (hashedItem.length) {

				// perform scroll down but add in 140 padding for the sticky header
				$('html, body').animate({scrollTop: hashedItem.offset().top},'slow');

			}
		}

		return false;

	});

	//--------------------------------------------
	// Pace
	//--------------------------------------------

	Pace.on('done', function() {

		if ($('#landing-vid-video').length) {

			document.getElementById('landing-vid-video').play();

		}

	});

	openSideNav();

	$(window).resize(function(){
		openSideNav();
	})

});

function openSideNav(activateForHome) {

	var hash = window.location.hash;

	if ($('body.page-template-template-home').length && hash.length === 0 && !activateForHome) {
		return;
	}

	changeNavColor();

	if ($(window).width() >= 1200 ) {
		$('body').addClass('nav-open');
	} else {
			$('body').removeClass('nav-open');
	}

}

function changeNavColor() {

	$('.menu-item-object-custom a').css('color', '#FFF');

	var url = window.location.href;

	$('.menu-item-object-custom a').each(function(){

		if ( $(this).attr('href') === url ) {
			$(this).css('color', '#666767');
		}

		// if ( $(this).parent().parent().parent().find('.current-menu-item').length ) {
		// 	$(this).parent().parent().parent().find('> a').css('color', '#fff');
		// }

	});

	// Change gf field * to * required field for accessibility consideration
	$(document).ready(function() {
			$(".gform_wrapper .gfield_required").html("* required field");
		});

}
